import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import Hero from "../../../../components/Hero";
import BlogMainContent from "./BlogMainContent";
import { Footer } from "../../../../components/Footer";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";

export default function DetailPage() {
  const apiBaseUrl = process.env.REACT_APP_API_PATH;
  const { slug } = useParams();
  const navigate = useNavigate();
  const [pages, setPages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`${apiBaseUrl}/pages/${slug}`);
        if (response.status === 200) {
          setIsLoading(false);
          setPages(response.data);
        }
      } catch (err) {
        navigate("/");
      }
    };
    fetchPage();
  }, [slug, apiBaseUrl]);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {isLoading === true ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {
            <Hero
              bgImage={pages.featuredImages && pages?.featuredImages[0]}
              imageText={{ title: pages?.title }}
            />
          }
          <BlogMainContent content={pages?.content} className="flex-grow" />
        </>
      )}

      <Footer />
    </div>
  );
}
